export const FEATURE_CART_EDIT_FLOW = 'cart-edit-flow';
